import { styled } from '@mui/material';
import { CoreBox, CoreTypography } from '@youscience/core';

export const StyledHeader = styled(CoreBox)(({ theme }) => ({
  backgroundColor: '#F9F9F9',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  paddingTop: '1.5rem',
  paddingBottom: '1rem',
}));

export const StyledContainer = styled('div')({
  maxWidth: '1280px',
  margin: '0 auto',
  padding: '0 1rem',
});

export const StyledNavBar = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '1.5rem',
  marginBottom: '2.5rem',
});

export const StyledContent = styled('div')({
  flex: 1,
  maxWidth: '624px',
  '& h1': {
    marginBottom: '0.5rem',
  },
});

export const sxStyles = {
  actionsWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: '1.5rem',
  },
};
